export { default as PointsEarnedBlock } from './points-earned';
